// DS: i3.4
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ArrowRight: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path d="M4.47381 1.24614L8.74713 5.40577C9.08429 5.73395 9.08429 6.26605 8.74713 6.59423L4.47381 10.7539C4.13666 11.082 3.59002 11.082 3.25287 10.7539C2.91571 10.4257 2.91571 9.89358 3.25287 9.5654L6.91525 5.99937L3.25287 2.4346C2.91571 2.10642 2.91571 1.57432 3.25287 1.24614C3.59002 0.917953 4.13666 0.917953 4.47381 1.24614Z" />
    </svg>
  </IconWrap>
);
ArrowRight.displayName = 'ArrowRight';

export default ArrowRight;
